module.exports = __webpack_public_path__ + "static/img/file_python.382356e2.png";